export default "__VITE_ASSET__CZiUvyur__"